// Export empty object as shim for node `fs` and `path`
export default {};
